import voterService from '@/services/voter.service';

const state = {
  id: '',
  name: null,
  election_id: null,
  created_on: '',
  email: '',
  has_voted: null,
  identifier: null,
  section_id: null,
  zoneNumber: null,
  local: {
    address: null,
    cep: null,
    district: null,
    latitude: null,
    longitude: null,
    name: null,
    neighborhood: null,
    number: null
  },
  showResult: false,
  isFirstAccess: true,
  region_id: null,
  cpf: null,
  rg: null,
  resultPasswordResetRequest: null,
  keyVerification: null,
  resultPasswordResetExecution: null
};

const mutations = {
  updateVoter: (state, payload) => {
    state.name = payload.voterName;
    state.identifier = payload.voterIdentifier;
    state.local.address = payload.localAddress;
    state.local.name = payload.localName;
  },
  updateShowResult: (state, value) => {
    state.showResult = value;
  },
  loadVoter: (state, payload) => {
    state.id = payload.id;
    state.name = payload.name;
    state.election_id = payload.election_id;
    state.email = payload.email;
    state.has_voted = payload.has_voted;
    state.identifier = payload.identifier;
    state.section_id = payload.section_id;
    state.isFirstAccess = payload.isFirstAccess;
    state.region_id = payload.region_id;
  },
  saveVoterPassword(state, params) {
    state.id = params.data.voterId;
    state.isFirstAccess = params.data.isFirstAccess;
  },
  resultPasswordReset(state, payload) {
    state.resultPasswordResetRequest = payload;
  },
  resultKeyVerification(state, payload) {
    state.keyVerification = payload;
  },
  resultPasswordResetExecution(state, payload) {
    state.resultPasswordResetExecution = payload;
  }
};

const getters = {
  showResult: state => {
    return state.showResult;
  }
};

const actions = {
  get: async ({ commit }, { idElection, voterIdentifier, typeIdentifier }) => {
    try {
      const result = await voterService.get(idElection, voterIdentifier);
      commit('updateVoter', result.data);
      commit('updateShowResult', true);
    } catch (error) {
      commit('updateShowResult', false);
      throw error;
    }
  },
  savePassElector({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      voterService
        .savePassElector({ voterId: credentials.voterId, password: credentials.password, electionId: credentials.electionId })
        .then(response => {
          if (
            response &&
            response.status &&
            response.status.toLowerCase() === 'ok'
          ) {
            commit('saveVoterPassword', { data: response.data, user: credentials });
            resolve();
          } else {
            reject('Usuário ou senha incorretos');
          }
        })
        .catch(error => reject(error));
    });
  },
  sendPasswordReset: async ({ commit }, jsonObject) => {
    const funcMutation = 'resultPasswordReset';
    return new Promise((resolve, reject) => {
      voterService.sendPasswordResetRequest(jsonObject)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  verifyKeyResetPassword: async ({ commit }, jsonObject) => {
    const funcMutation = 'resultKeyVerification';
    return new Promise((resolve, reject) => {
      voterService.verifyKeyResetPassword(jsonObject)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  sendPasswordResetExecution: async ({ commit }, jsonObject) => {
    const funcMutation = 'resultPasswordResetExecution';
    return new Promise((resolve, reject) => {
      voterService.sendPasswordResetExecution(jsonObject)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  loadVoter: async ({ commit }, { voterJson }) => {
    commit('loadVoter', voterJson);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
